



import React, { createContext, useState, useContext } from "react";

const EnergiaHvacIndiretaContext = createContext();

export default function AmbienteProvider({ children }) {
  const [energiaHvacExpansaoIndireta_id, setEnergiaHvacExpansaoIndireta_id] = useState();

  return (
    <EnergiaHvacIndiretaContext.Provider value={{ energiaHvacExpansaoIndireta_id, setEnergiaHvacExpansaoIndireta_id }} >
      {children}
    </EnergiaHvacIndiretaContext.Provider>
  );
}

export function useEnergiaHvacIndiretaContext() {
  const context = useContext(EnergiaHvacIndiretaContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { energiaHvacExpansaoIndireta_id, setEnergiaHvacExpansaoIndireta_id } = context;
  return { energiaHvacExpansaoIndireta_id, setEnergiaHvacExpansaoIndireta_id };
}

